<formly-form [fields]="fields" [form]="form">
</formly-form>
